import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'

import { requestPasswordReset } from '../api/auth'
import { ApiError } from '../api/client'
import { AuthScreenLayout } from '../components/auth/AuthScreenLayout'
import { MailIcon } from '../components/auth/AuthIcons'

export const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setLoading(true)
    setError(null)
    setMessage(null)
    try {
      await requestPasswordReset(email.trim())
      setMessage('Если email зарегистрирован, мы отправили ссылку для сброса пароля.')
    } catch (resetError) {
      if (resetError instanceof ApiError) {
        setError(resetError.message || 'Не удалось отправить запрос')
      } else {
        setError(resetError instanceof Error ? resetError.message : 'Не удалось отправить запрос')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthScreenLayout>
      <div className="market-auth__card">
        <header className="market-auth__card-header">
          <h2 className="market-auth__card-title">Сброс пароля</h2>
          <p className="market-auth__card-lead">Введите email — пришлём ссылку для нового пароля</p>
        </header>

        <form className="market-auth__form" onSubmit={(event) => void handleSubmit(event)}>
          <label className="market-auth-field">
            <span className="market-auth-field__label">
              Email <span className="market-auth-field__required">*</span>
            </span>
            <span className="market-auth-field__control">
              <MailIcon className="market-auth-field__icon" />
              <input
                className="market-auth-field__input"
                type="email"
                autoComplete="email"
                placeholder="Введите email"
                required
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </span>
          </label>

          {message ? <p className="market-auth__message">{message}</p> : null}
          {error ? (
            <p className="echat-error market-auth__error" role="alert">
              {error}
            </p>
          ) : null}

          <button type="submit" className="echat-btn echat-btn--primary market-auth__submit" disabled={loading}>
            {loading ? 'Отправка…' : 'Отправить ссылку'}
          </button>
        </form>

        <div className="market-auth__footer">
          <Link className="market-auth__back-link" to="/login">
            ← Вернуться ко входу
          </Link>
        </div>
      </div>
    </AuthScreenLayout>
  )
}
